export default __webpack_public_path__ + "static/media/ktn-white.a347b4ab.png";